import { highlightMatches } from '~/utils/highlight-match'

/** `text`, avec les mots de `query` marqués — accents et casse ignorés (#109). */
function HighlightedText({ text, query }: { text: string, query: string }) {
  return (
    <>
      {highlightMatches(text, query).map((segment, index) => segment.match
        // Segments recalculés à chaque rendu, dans l'ordre du texte : l'indice
        // est leur seule identité stable.
        // eslint-disable-next-line react/no-array-index-key
        ? <mark key={index} className="rounded-sm bg-primary/15 font-semibold text-inherit">{segment.text}</mark>
        // eslint-disable-next-line react/no-array-index-key
        : <span key={index}>{segment.text}</span>)}
    </>
  )
}

export default HighlightedText
